import { Injectable } from '@angular/core';
import { Session } from '../models/sessionmodel';
import { Router } from '@angular/router';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/startWith';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class SharedService {
  public session: Session;

  constructor(public router: Router) {
  }

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  logout() {
    localStorage.removeItem("mca_d");
    localStorage.removeItem("access_token");
    this.router.navigate(['/login']);
  }

  checkCredentials() {
    //console.log("MCA : "+ localStorage.getItem("mca"));
    if (localStorage.getItem("mca_d") === null) {
      if (localStorage.getItem("mca")) {
        localStorage.removeItem("mca");
      }
      return false;
    }
    else {
      //this.session = JSON.parse(localStorage.getItem("mca"));      
      return true;
    }
  }

  isAdmin() {

    if (this.session.account_role === "admin") {
      return true;
    }
    else {
      return false;
    }
  }

  isViewer() {

    if (this.session.account_role === "viewer") {
      return true;
    }
    else {
      return false;
    }
  }

  isMerchant() {
    if (this.session.account_role === "merchant") {
      return true;
    }
    else {
      return false;
    }
  }

  isMerchantUser() {
    if (this.session.account_role === "merchantuser") {
      return true;
    }
    else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /tmp/build_713add00/src/services/sharedservices.service.ts